import { useT } from "@/lib/i18n";
import { Reveal } from "./Reveal";
import { SectionHeading } from "./SectionHeading";
import { SECTION_CLS } from "./Releases";

export const About = () => {
  const t = useT();

  return (
    <section id="about" data-testid="about-section" className={SECTION_CLS}>
      <SectionHeading
        index={t.about.index}
        eyebrow={t.about.eyebrow}
        title={t.about.title}
        testId="about-heading"
      />
      <div className="grid gap-px border border-if-line bg-if-line md:grid-cols-3">
        {t.about.chapters.map((c, i) => (
          <Reveal key={c.num} delay={i * 0.12} className="h-full">
            <div
              data-testid={`about-chapter-${c.num}`}
              className="h-full bg-if-black p-10 md:p-12"
            >
              <span className="font-sans text-2xl font-light leading-none tracking-[0.2em] text-if-gold/50">
                {c.num}
              </span>
              <h3 className="mt-8 font-sans text-xs font-medium uppercase tracking-[0.3em] text-if-text">
                {c.title}
              </h3>
              <p className="mt-4 text-sm font-light leading-relaxed text-if-dim">
                {c.text}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
};
